import { Box, Tab, Typography, makeStyles } from '@material-ui/core'
import { TabContext, TabList, TabPanel } from '@material-ui/lab'
import Button from 'components/Button'
import PropTypes from 'prop-types'
import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getTipoUsuarioLogado } from 'store/modules/auth/auth.selectors'
import { TIPO_USUARIO } from 'utils/constantes'
import TabAgua from './TabAgua'
import TabRegioes from './TabRegioes'

export const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.grey.main}`,
  },
  screenTitle: {
    display: 'flex',
    alignItems: 'center',
    height: theme.spacing(5),
    fontSize: theme.typography.pxToRem(24),
  },
  panel: {
    padding: theme.spacing(4, 0),
  },
  tabIndicator: {
    height: 4,
    transform: 'scaleX(0.8)',
    borderRadius: theme.spacing(2, 2, 0, 0),
    backgroundColor: theme.palette.blue.main,
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.grey.main}`,
  },
  tabList: {
    '& .MuiTab-root': {
      '&.Mui-selected': {
        color: '#31ADE3',
      },
    },
  },
}))

const Agua = ({ paisId }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const tipoUsuarioLogado = useSelector(getTipoUsuarioLogado)

  const desabilitarFormulario = Boolean(tipoUsuarioLogado === TIPO_USUARIO.ADMIN.OBSERVADOR)

  const tabs = [
    { key: '0', title: t('paisesCalculos.TiposAgua'), component: TabAgua },
    { key: '1', title: t('paisesCalculos.RegioesHidrograficas'), component: TabRegioes },
  ]

  const [currentTab, setCurrentTab] = useState(tabs[0].key)

  const titleButton = () => {
    switch (currentTab) {
      case '0':
        return t('inputs.AdicionarTipoAgua')
      case '1':
        return t('inputs.AdicionarRegiao')
      default:
        return 'undefined'
    }
  }

  const [controlAdded, setControlAdded] = useState(false)
  const childRef = useRef()

  const hearChange = () => {
    if (controlAdded) {
      setControlAdded(false)
    }
  }

  return (
    <>
      <div className={classes.sectionTitle}>
        <Typography className={classes.screenTitle}>
          {t('paisesCalculos.Agua')}
        </Typography>
      </div>
      <TabContext value={currentTab}>
        <div className={classes.sectionHeader}>
          <Box>
            <TabList
              classes={{ indicator: classes.tabIndicator }}
              className={classes.tabList}
            >
              {
            tabs.map((elem, index) => (
              <Tab
                label={elem.title}
                value={elem.key}
                key={index}
                onClick={() => { hearChange(); setCurrentTab(elem.key) }}
              />
            ))
          }
            </TabList>
          </Box>
          <Button
            disabled={controlAdded || desabilitarFormulario}
            onClick={() => { childRef.current.handleButtonAdded() }}
          >
            {titleButton()}
          </Button>
        </div>
        { tabs.map(({ component: Component, ...tab }) => (
          <TabPanel className={classes.panel} value={tab.key} key={tab.key}>
            <Component
              paisId={paisId}
              controlAdded={controlAdded}
              setControlAdded={setControlAdded}
              ref={childRef}
            />
          </TabPanel>
        ))}
      </TabContext>
    </>
  )
}

Agua.propTypes = {
  paisId: PropTypes.number,
}

export default Agua
